// box-for-checkbox.component.ts
import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';

@Component({
  selector: 'app-box-for-checkbox',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <div
      class="relative w-5 h-5 flex items-center justify-center"
      [class.cursor-pointer]="!disabled"
      [class.opacity-50]="disabled"
      (click)="onToggle()"
    >
      <div *ngIf="checked" class="absolute w-5 h-5 bg-theme-primary rounded"></div>
      <i *ngIf="checked" class="fas fa-check text-sm text-theme-surface2 z-10"></i>
      <div class="absolute w-5 h-5 border-2 border-theme-primary rounded"></div>
    </div>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BoxForCheckboxComponent),
      multi: true
    }
  ]
})
export class BoxForCheckboxComponent implements ControlValueAccessor {
  @Input() disabled = false;
  @Output() change = new EventEmitter<boolean>();

  checked = false;
  private onChange = (_: boolean) => {};
  private onTouched = () => {};

  onToggle() {
    if (!this.disabled) {
      this.checked = !this.checked;
      this.onChange(this.checked);
      this.onTouched();
      this.change.emit(this.checked);
    }
  }

  // ControlValueAccessor implementation
  writeValue(value: boolean): void {
    this.checked = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
